import "swiper/css";
import "./vendor/select2/select2.min.css";
import "../src/scss/main.scss";

import "./vendor/jquery/jquery.min.js";
import "./vendor/jquery/jquery.validate.min.js";
import "./vendor/select2/select2.min.js";

import Swiper from "swiper/bundle";
window.Swiper = Swiper;

import { parseCountryValue, validatePhoneNumber } from "./js/phoneValidation.js";
window.parseCountryValue = parseCountryValue;
window.validatePhoneNumber = validatePhoneNumber;

import { initAutoCountryAndArea } from "./js/autoCountryFill.js";
window.initAutoCountryAndArea = initAutoCountryAndArea;

import "./js/pass-cid-to-forms.js";

import "./js/main.js";
import "./js/validate.js";